// DEV-163: "+ Add" for the cart drawer's Finish the Bed row
// (snippets/core--cart-finish-bed.liquid).
//
// Adds one unit of the chosen variant and asks Shopify for the cart sections
// in the same request, then announces the change with Horizon's own CartAddEvent.
// That one event is what every cart surface already listens for: the drawer's
// cart-items-component morphs in the returned section (which also re-renders
// this row, so the added piece drops out of it), and the agency header's Alpine
// cart store refetches its count. Nothing here touches the drawer's markup.
//
// Delegated from document so it keeps working after each morph replaces the row.

import { CartAddEvent } from '@theme/events';

const ROOT = '.pr-finish-bed';

function sectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
    .filter(Boolean);
}

function setStatus(root, text) {
  const status = root?.querySelector('[data-finish-bed-status]');
  if (status) status.textContent = text;
}

async function add(button) {
  const card = button.closest('.pr-finish-bed__card');
  const root = button.closest(ROOT);
  const select = card?.querySelector('[data-finish-bed-select]');
  const id = Number(select instanceof HTMLSelectElement ? select.value : button.dataset.variantId);
  if (!id || button.disabled) return;

  const label = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding';
  setStatus(root, '');

  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id, quantity: 1 }],
        sections: sectionIds().join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();

    if (!response.ok || data.status) {
      setStatus(root, data.description || data.message || 'That piece could not be added. Please try again.');
      button.disabled = false;
      button.textContent = label;
      return;
    }

    // Hand listeners the whole cart, as the drawer's quantity buttons do:
    // without it every product form on the page (each quick-add card) fetches
    // /cart.js on its own (measured: ~30 requests on a product page).
    const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
      .then((r) => r.json())
      .catch(() => ({}));

    document.dispatchEvent(
      new CartAddEvent(cart, `pr-finish-bed-${id}`, {
        source: 'pr-finish-bed',
        itemCount: 1,
        variantId: String(id),
        sections: data.sections,
      })
    );
  } catch (error) {
    console.error('Finish the Bed add failed:', error);
    setStatus(root, 'That piece could not be added. Please try again.');
    button.disabled = false;
    button.textContent = label;
  }
}

if (!window.__prFinishBed) {
  window.__prFinishBed = true;

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element && event.target.closest(`${ROOT} [data-finish-bed-add]`);
    if (button instanceof HTMLButtonElement) add(button);
  });

  // Keep the shown price on the size the shopper picked.
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches(`${ROOT} [data-finish-bed-select]`)) return;
    const price = select.closest('.pr-finish-bed__card')?.querySelector('[data-finish-bed-price]');
    const option = select.selectedOptions[0];
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  });
}
